import './App.css';
import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { AuthProvider } from './contexts/authContext';
import { useAuth } from './contexts/authContext';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { getUserDatabase } from './data/AsyncFunctions/getUserDatabase';
import Login from './pages/Login/Login'
import Fridge from './pages/Fridge/Fridge';
import Scan from './pages/Scan/Scan';
import Account from "./pages/Account/Account";
import Signup from "./pages/Login/Signup";

function DatabaseBootstrapper() {
  const dispatch = useDispatch();
  const { userLoggedIn } = useAuth();

  useEffect(() => {
    let isMounted = true;

    const bootstrapDatabase = async () => {
      if (!userLoggedIn) {
        dispatch({ type: 'RESET_USER_DATABASE' });
        return;
      }

      const userDatabase = await getUserDatabase(userLoggedIn);

      if (isMounted) {
        dispatch({
          type: 'HYDRATE_USER_DATABASE',
          payload: userDatabase,
        });
      }
    };

    bootstrapDatabase();

    return () => {
      isMounted = false;
    };
  }, [dispatch, userLoggedIn]);

  return null;
}

function App() {
  return (
    <AuthProvider>
      <DatabaseBootstrapper />
      <Router>
        <Routes>
          <Route path="/fridge" element={<Fridge />} />
          <Route path="/scan" element={<Scan />} />
          <Route path="/" element={<Login />} />
          <Route path="/login" element={<Login />} />
          <Route path="/account" element={<Account />} />
          <Route path="/sign-up" element={<Signup />} />
          <Route path="/signup" element={<Signup />} />
        </Routes>
      </Router>
    </AuthProvider>
  );
}

export default App;
